import { useEffect, useState } from 'react';

import styles from './pagination.module.scss';
import PaginationArrow from './PaginationArrow';

function PaginationSection({ range, setPage, page, slice }) {
  const [truncatedPages, setTruncatedPages] = useState([]);

  useEffect(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }

    const arrayOfArrays = splitArrayIntoSmallerArrays(range);
    setTruncatedPages(
      calculatePagesTruncation(page, range.length, 5, arrayOfArrays)
    );
  }, [slice, page, setPage]);

  const splitArrayIntoSmallerArrays = (range) => {
    const bigArray = [...range];
    const maxPages = 5;

    const size = 3;
    const arrayOfArrays = [];

    if (bigArray.length > maxPages) {
      const firstPages = bigArray.splice(0, maxPages - 1);
      arrayOfArrays.push(firstPages);
    }

    for (let i = 0; i < bigArray.length; i += size) {
      arrayOfArrays.push(bigArray.slice(i, i + size));
    }

    return arrayOfArrays;
  };

  const calculatePagesTruncation = (
    currentPageNumber,
    totalPages,
    maxButtons = 5,
    arrayOfArrays
  ) => {
    function findPagesToShow(currentPageNumber) {
      const truncatedPages = arrayOfArrays.find((arr) =>
        arr.includes(currentPageNumber)
      );

      return truncatedPages;
    }

    // No need to truncate
    if (totalPages <= maxButtons) {
      return range;
    } else {
      let truncatedPagesToShow = [];

      if (currentPageNumber < maxButtons) {
        const truncatedPages = findPagesToShow(currentPageNumber);
        truncatedPagesToShow.push.apply(truncatedPagesToShow, truncatedPages);
        truncatedPagesToShow.push(0);
        truncatedPagesToShow.push(totalPages);
      }

      // First elements should be the first page and "..."
      if (currentPageNumber >= maxButtons) {
        truncatedPagesToShow[0] = 1;
        truncatedPagesToShow[1] = 0;

        const truncatedPages = findPagesToShow(currentPageNumber);
        truncatedPagesToShow.push.apply(truncatedPagesToShow, truncatedPages);

        // Last page is in sight - we don't want "..." and last page appended
        if (truncatedPages.includes(totalPages)) {
          return truncatedPagesToShow;
        }

        // This should only be done if the last page isn't in the "truncatedPages"-array
        truncatedPagesToShow.push(0);
        truncatedPagesToShow.push(totalPages);
      }

      return truncatedPagesToShow;
    }
  };

  return (
    <div
      className={`${
        range.length > 1 ? 'd-flex' : 'd-none'
      } justify-content-center align-items-center`}
    >
      <div className='d-flex justify-content-between align-items-center gap-5'>
        <PaginationArrow
          type='previous'
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        />

        <div className='d-flex gap-2 align-items-end'>
          {truncatedPages.map((el, index) => {
            return el === 0 ? (
              <span key={index} className='material-symbols-outlined'>
                more_horiz
              </span>
            ) : (
              <button
                key={index}
                className={`rounded border-0 px-2 py-1 ${
                  page === el ? 'bg-black text-white' : 'bg-transparent'
                } ${styles.btn}`}
                onClick={() => setPage(el)}
              >
                {el}
              </button>
            );
          })}
        </div>

        <PaginationArrow
          type='forward'
          disabled={page === range.length}
          onClick={() => setPage(page + 1)}
        />
      </div>
    </div>
  );
}

export default PaginationSection;
